import GetLogin from '../../components/perfil/GetLogin';

function Login() {
  return <GetLogin />;
}

export default Login;
